<template lang="html">
  <div class="province-F">
    <div
      v-show="!dialogVisible"
      style="display: grid; place-items: end; width: 250px; position: absolute; right: 10px; z-index: 1999">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="主题">
          <el-select v-model="chartTheme" size="small" placeholder="请选择" @change="(val) => handleChangeTheme(val)">
            <el-option v-for="item in themes" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="企业情况" name="1">
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>出版单位音像电子资质统计</h3>
                <p>
                  音像电子出版单位总数量：<span class="numStyle">{{ txtNums[0] }}</span> 家
                </p>
                <p>
                  既有音像又有电子资质的出版单位数量：<span class="numStyle">{{ txtNums[1] }}</span> 家
                </p>
                <p>
                  只有音像资质的出版单位数量：<span class="numStyle">{{ txtNums[2] }}</span> 家
                </p>
                <p>
                  只有电子资质的出版单位数量：<span class="numStyle">{{ txtNums[3] }}</span> 家
                </p>
                <p>
                  具有音像资质的出版单位数量：<span class="numStyle">{{ txtNums[4] }}</span> 家
                </p>
                <p>
                  具有电子资质的出版单位数量：<span class="numStyle">{{ txtNums[5] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <hbar-chart
              :key="roundKey + '_2'"
              :params="{
                id: 'chart_2',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></hbar-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>出版单位出版资质统计</h3>
                <p>
                  具有图书资质的出版单位数量：<span class="numStyle">{{ txtNums2[0] }}</span> 家
                </p>
                <p>
                  具有期刊资质的出版单位数量：<span class="numStyle">{{ txtNums2[1] }}</span> 家
                </p>
                <p>
                  具有报纸资质的出版单位数量：<span class="numStyle">{{ txtNums2[2] }}</span> 家
                </p>
                <p>
                  具有网络资质的出版单位数量：<span class="numStyle">{{ txtNums2[3] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <pie-chart
                :key="roundKey + '_3'"
                :params="{
                  id: 'chart_3',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></pie-chart>
              <el-col id="sel_chart_3" :span="24" style="text-align: center; margin-top: -30px">
                <el-checkbox-group v-model="checkListZj" @change="chagenZjVal" style="padding: 0px 0px 10px 0px">
                  <el-checkbox v-for="(name, index) in listZj" :label="name" :key="name"></el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_5'"
              :params="{
                id: 'chart_5',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <pie-chart
                :key="roundKey + '_4'"
                :params="{
                  id: 'chart_4',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></pie-chart>
              <el-col id="sel_chart_4" :span="24" style="text-align: center; margin-top: -30px">
                <el-checkbox-group v-model="checkListZj2" @change="chagenZjVal2" style="padding: 0px 0px 10px 0px">
                  <el-checkbox v-for="(name, index) in listZj2" :label="name" :key="name"></el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>单位性质统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_7'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_7"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <bing-chart
                :key="roundKey + '_7'"
                :params="{
                  id: 'chart_7',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></bing-chart>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>法人类型统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_6'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_6"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <pie-chart
                :key="roundKey + '_6'"
                :params="{
                  id: 'chart_6',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></pie-chart>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!--      <el-tab-pane label="法人类型" name="2">-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="音像制品" name="3">
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_183'"
                :params="{
                  id: 'chart_183',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <bar-chart
                :key="roundKey + '_181'"
                :params="{
                  id: 'chart_181',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></bar-chart>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_182'"
                :params="{
                  id: 'chart_182',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像出版单位出版品种数分段统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_11'])" :key="key">
                  出版品种为{{ key }}的出版单位：<span class="numStyle">{{ txtNumsData["chart_11"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <bar-chart
                :key="roundKey + '_11'"
                :params="{
                  id: 'chart_11',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></bar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像制品载体形式统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_15'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_15"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_15'"
              :params="{
                id: 'chart_15',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像制品内容来源类型统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_13'])" :key="key">
                  内容来源类型{{ key }}数量：<span class="numStyle">{{ txtNumsData["chart_13"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_13'"
              :params="{
                id: 'chart_13',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像制品节目时长分段统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_12'])" :key="key">
                  时长分段{{ key }}的节目数量：<span class="numStyle">{{ txtNumsData["chart_12"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_12'"
              :params="{
                id: 'chart_12',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像制品书配盘统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_14'])" :key="key">
                  书配盘{{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_14"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_14'"
              :params="{
                id: 'chart_14',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度音像制品出版渠道统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_16'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_16"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_16'"
              :params="{
                id: 'chart_16',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row> -->
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度除传统光盘载体外音像制品出版单位拓展方向分布情况</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_17'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_17"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_17'"
              :params="{
                id: 'chart_17',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年音像制品出版单位结合音像电子业务开设并运营的项目分布情况</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_18'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_18"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_18'"
              :params="{
                id: 'chart_18',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="电子出版物" name="4">
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_283'"
                :params="{
                  id: 'chart_283',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <bar-chart
                :key="roundKey + '_281'"
                :params="{
                  id: 'chart_281',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></bar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_282'"
                :params="{
                  id: 'chart_282',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"
                :barType="'line'"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子出版单位出版品种数分段统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_21'])" :key="key">
                  出版品种为{{ key }}的出版单位：<span class="numStyle">{{ txtNumsData["chart_21"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <bar-chart
                :key="roundKey + '_21'"
                :params="{
                  id: 'chart_21',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></bar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子载体形式统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_25'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_25"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_25'"
              :params="{
                id: 'chart_25',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子出版物内容来源类型统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_23'])" :key="key">
                  内容来源类型{{ key }}数量：<span class="numStyle">{{ txtNumsData["chart_23"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_23'"
              :params="{
                id: 'chart_23',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子出版物数据容量分段统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_22'])" :key="key">
                  数据容量分段{{ key }}的节目数量：<span class="numStyle">{{ txtNumsData["chart_22"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_22'"
              :params="{
                id: 'chart_22',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子出版物书配盘统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_24'])" :key="key">
                  书配盘{{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_24"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_24'"
              :params="{
                id: 'chart_24',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度电子出版物出版渠道统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_26'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_26"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_26'"
              :params="{
                id: 'chart_26',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row> -->
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年度除传统光盘载体外电子出版物出版单位拓展方向分布情况</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_27'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_27"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_27'"
              :params="{
                id: 'chart_27',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>2023-2024年电子出版物出版单位结合音像电子业务开设并运营的项目分布情况</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_28'])" :key="key">
                  {{ key }}的数量：<span class="numStyle">{{ txtNumsData["chart_28"][key] }}</span> 个
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bar-chart
              :key="roundKey + '_28'"
              :params="{
                id: 'chart_28',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bar-chart>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="经营情况" name="business">
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_51'"
                :params="{
                  id: 'chart_51',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="24">
            <el-card shadow="always" body-style="padding:0px;width:100%;">
              <mbar-chart
                :key="roundKey + '_52'"
                :params="{
                  id: 'chart_52',
                  data: dataArray,
                  chartHeight,
                  chartTheme,
                  columnMap,
                  imgUrlfdj,
                  imgUrldata,
                  imgUrldownload,
                }"
                :searchData="searchData"
                :queryFilter="queryFilter"
                :queryVisible="queryVisible"
                :querySort="querySort"
                :backEcharts="backEcharts"
                :chartResize="chartResize"
                :setDisplayVisible="setDisplayVisible"
                :sortData="sortData"
                :downloadData="downloadData"
                :createDataHtml="createDataHtml"
                :setQueryVisible="setQueryVisible"
                :listTableData="listTableData"></mbar-chart>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="margin-top: 15px; padding: 0px 15px 0px 0px">
          <el-col :span="24">
            <chart-finance
              style="padding: 0px; width: 100%"
              :chart-theme="this.chartTheme"
              :active-name="this.activeName">
            </chart-finance>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="margin-top: 15px; padding: 0px 15px 0px 0px">
          <el-col :span="24">
            <province-finance
              style="padding: 0px; width: 100%"
              :chart-theme="this.chartTheme"
              :active-name="this.activeName">
            </province-finance>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="人员整体情况" name="worker">
        <worker-base style="padding: 0px; width: 100%" :chart-theme="this.chartTheme" :active-name="this.activeName">
        </worker-base>
      </el-tab-pane>
      <el-tab-pane label="各单位人员情况" name="5">
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>音像电子人员职称统计</h3>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_38'])" :key="key">
                  {{ index == 0 ? key : key + "职称" }}：<span class="numStyle">{{
                    txtNumsData["chart_38"][key]
                  }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bing-chart
              :key="roundKey + '_38'"
              :params="{
                id: 'chart_38',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bing-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>职称系列统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_37'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_37"][key] }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_37'"
              :params="{
                id: 'chart_37',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>出版专业人员职称统计</h3>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_39'])" :key="key">
                  {{ index == 0 ? key : key + "职称" }}：<span class="numStyle">{{
                    txtNumsData["chart_39"][key]
                  }}</span>
                  人
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_39'"
              :params="{
                id: 'chart_39',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="4">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>领导班子成员持证上岗率统计</h3>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_45'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_45"][key] }}</span>
                </p>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_41'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_41"][key] }}</span>
                </p>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_44'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_44"][key] }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="0" style="padding: 0px 0px 0px 0px">
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_45'"
                  :params="{
                    id: 'chart_45',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_41'"
                  :params="{
                    id: 'chart_41',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_44'"
                  :params="{
                    id: 'chart_44',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="4">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>编辑人员统计</h3>
                <p v-for="(key, index) in Object.keys(txtNumsData['chart_42'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_42"][key] }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="0" style="padding: 0px 0px 0px 0px">
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_42'"
                  :params="{
                    id: 'chart_42',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_46'"
                  :params="{
                    id: 'chart_46',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
              <el-col :span="8">
                <bing-chart
                  :key="roundKey + '_47'"
                  :params="{
                    id: 'chart_47',
                    data: dataArray,
                    chartHeight,
                    chartTheme,
                    columnMap,
                    imgUrlfdj,
                    imgUrldata,
                    imgUrldownload,
                  }"
                  :searchData="searchData"
                  :queryFilter="queryFilter"
                  :queryVisible="queryVisible"
                  :querySort="querySort"
                  :backEcharts="backEcharts"
                  :chartResize="chartResize"
                  :setDisplayVisible="setDisplayVisible"
                  :sortData="sortData"
                  :downloadData="downloadData"
                  :createDataHtml="createDataHtml"
                  :setQueryVisible="setQueryVisible"
                  :listTableData="listTableData"></bing-chart>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>政治面貌统计</h3>
                <p
                  v-for="key in Object.keys(txtNumsData['chart_35'])"
                  :key="key"
                  style="width: 40%; float: left; margin-bottom: 0px">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_35"][key] }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_35'"
              :params="{
                id: 'chart_35',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>文化程度统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_36'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_36"][key] }}</span>
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_36'"
              :params="{
                id: 'chart_36',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>音像及电子中级职称人数统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_31'])" :key="key">
                  {{ key }}：<span class="numStyle">{{ txtNumsData["chart_31"][key] }}</span> 人
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <hbar-chart
              :key="roundKey + '_31'"
              :params="{
                id: 'chart_31',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></hbar-chart>
          </el-col>
        </el-row> -->

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>出版专业职业资格中级及以上职称占比统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_32'])" :key="key">
                  中级及以上职称占比{{ key }}数量：<span class="numStyle">{{ txtNumsData["chart_32"][key] }}</span> 家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_32'"
              :params="{
                id: 'chart_32',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        <!--
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>领导班子岗位培训合格证书持有占比情况</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_33'])" :key="key">
                  领导班子岗位培训合格证书持有占比{{ key }}数量：<span class="numStyle">{{
                    txtNumsData["chart_33"][key]
                  }}</span>
                  家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_33'"
              :params="{
                id: 'chart_33',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>
        -->
        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>领导班子出版专业职业资格证书中级及以上占比统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_34'])" :key="key">
                  领导班子出版专业职业资格证书中级及以上占比{{ key }}数量：<span class="numStyle">{{
                    txtNumsData["chart_34"][key]
                  }}</span>
                  家
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <pie-chart
              :key="roundKey + '_34'"
              :params="{
                id: 'chart_34',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></pie-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>各专业高级职称编辑人数统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_40'])" :key="key">
                  各专业高级职称编辑{{ key }}的人数：<span class="numStyle">{{ txtNumsData["chart_40"][key] }}</span> 人
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bing-chart
              :key="roundKey + '_40'"
              :params="{
                id: 'chart_40',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bing-chart>
          </el-col>
        </el-row>

        <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
          <el-col :span="12">
            <el-card shadow="always" body-style="padding:0px;width:100%;" :style="chartHeight">
              <div class="text-introduce">
                <h3>各专业中级职称编辑人数统计</h3>
                <p v-for="key in Object.keys(txtNumsData['chart_43'])" :key="key">
                  各专业中级职称编辑{{ key }}的人数：<span class="numStyle">{{ txtNumsData["chart_43"][key] }}</span> 人
                </p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <bing-chart
              :key="roundKey + '_43'"
              :params="{
                id: 'chart_43',
                data: dataArray,
                chartHeight,
                chartTheme,
                columnMap,
                imgUrlfdj,
                imgUrldata,
                imgUrldownload,
              }"
              :searchData="searchData"
              :queryFilter="queryFilter"
              :queryVisible="queryVisible"
              :querySort="querySort"
              :backEcharts="backEcharts"
              :chartResize="chartResize"
              :setDisplayVisible="setDisplayVisible"
              :sortData="sortData"
              :downloadData="downloadData"
              :createDataHtml="createDataHtml"
              :setQueryVisible="setQueryVisible"
              :listTableData="listTableData"></bing-chart>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="连续型电子出版物" name="lxdzfinace">
        <el-row :gutter="15" style="padding: 0px 15px 0px 0px">
          <el-col :span="24">
            <lxdz-finance
              style="padding: 0px; width: 100%"
              :chart-theme="this.chartTheme"
              :active-name="this.activeName">
            </lxdz-finance>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title=""
      top="6vh"
      @opened="openedDialog"
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      width="94%">
      <div class="panel panel-default panel-intro">
        <div class="panel-body">
          <div id="myTabContent" class="tab-content">
            <el-row :gutter="20">
              <el-col :span="14">
                <el-card shadow="always" body-style="padding:0px;width:100%;">
                  <div id="echart_n" style="width: 100%"></div>
                </el-card>
              </el-col>
              <el-col :span="10">
                <el-card shadow="always" body-style="padding:0px;width:100%;">
                  <div class="echart_table" style="display: block" id="echart_n_table">
                    <div style="width: 100%; height: 34px; line-height: 34px">
                      <div style="width: 60px; float: left; text-align: center">
                        <i
                          @click="downloadData('chart_n')"
                          class="fa fa-download searchFilerCls"
                          aria-hidden="true"
                          title="导出"></i>
                      </div>
                      <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
                        <el-col
                          v-for="(key, index) in currentId ? Object.keys(columnMap[currentId]) : []"
                          :key="key"
                          :span="(currentId ? Object.keys(columnMap[currentId]) : []).length <= 4 ? 6 : 4">
                          <el-select
                            v-if="
                              (currentId == 'chart_11' ||
                                currentId == 'chart_12' ||
                                currentId == 'chart_21' ||
                                currentId == 'chart_22') &&
                              key == 'value'
                            "
                            v-model="queryFilterN[key]"
                            size="mini"
                            placeholder="请选择"
                            @change="searchData('chart_n')">
                            <el-option v-for="item in Object.keys(rangeValus)" :key="item" :label="item" :value="item">
                            </el-option>
                          </el-select>
                          <el-input
                            v-else
                            @input="onInput()"
                            v-model="queryFilterN[key]"
                            clearable
                            size="mini"
                            :placeholder="'请输入' + columnMap[currentId][key]"
                            style="margin-top: 0px; margin-bottom: 3px"
                            class="searchInput">
                            <el-button
                              @click="searchData('chart_n')"
                              slot="append"
                              size="mini"
                              icon="el-icon-search"></el-button>
                          </el-input>
                        </el-col>
                      </el-row>
                    </div>
                    <table
                      id="echart_n_tab"
                      style="width: 100%"
                      class="tabletemp table-striped table-bordered tabletemp-hover">
                      <thead>
                        <tr>
                          <th>
                            <div
                              title="返回"
                              class="th-inner"
                              style="text-align: center"
                              @click="backEcharts('chart_n')"></div>
                            <div class="fht-cell"></div>
                          </th>
                          <th
                            v-for="(key, index) in currentId ? Object.keys(columnMap[currentId]) : []"
                            :key="key"
                            nowrap="nowrap">
                            <div class="th-inner text-warning">
                              {{ columnMap[currentId][key] }}
                              <i
                                @click="sortData('chart_n', key, querySort['chart_n'][key])"
                                :class="
                                  querySort['chart_n'][key] == 'sort'
                                    ? 'fa fa-sort'
                                    : querySort['chart_n'][key] == 'asc'
                                    ? 'fa fa-sort-asc'
                                    : querySort['chart_n'][key] == 'desc'
                                    ? 'fa fa-sort-desc'
                                    : ''
                                "
                                :style="querySort['chart_n'][key] == 'sort' ? 'color: #e3dfdfff' : ''"></i>
                              <!--                              <i-->
                              <!--                                v-if="index == (currentId ? Object.keys(columnMap[currentId]) : []).length - 1"-->
                              <!--                                @click="setQueryVisible('chart_n')"-->
                              <!--                                class="fa fa-filter searchFilerCls"-->
                              <!--                                aria-hidden="true"-->
                              <!--                                title="筛选" />-->
                              <!--                              <i-->
                              <!--                                v-if="index == (currentId ? Object.keys(columnMap[currentId]) : []).length - 1"-->
                              <!--                                @click="downloadData('chart_n')"-->
                              <!--                                class="fa fa-download searchFilerCls"-->
                              <!--                                aria-hidden="true"-->
                              <!--                                title="导出" />-->
                            </div>
                            <!--                            <div class="fht-cell">-->
                            <!--                              <el-input-->
                            <!--                                @input="onInput()"-->
                            <!--                                v-if="queryVisible.chart_n"-->
                            <!--                                v-model="queryFilterN[key]"-->
                            <!--                                clearable-->
                            <!--                                size="mini"-->
                            <!--                                :key="key"-->
                            <!--                                placeholder="请输入内容"-->
                            <!--                                class="searchInput">-->
                            <!--                                <el-button-->
                            <!--                                  @click="searchData('chart_n')"-->
                            <!--                                  slot="append"-->
                            <!--                                  size="mini"-->
                            <!--                                  icon="el-icon-search"></el-button>-->
                            <!--                              </el-input>-->
                            <!--                            </div>-->
                          </th>
                        </tr>
                      </thead>
                      <tbody id="echart_n_html" style="font-size: 14px !important">
                        <tr>
                          <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";
import chartFinance from "@/components/ChartFinance/StatisticalFinance.vue";
import provinceFinance from "@/components/ChartFinance/ProvinceFinance.vue";
import lxdzFinance from "@/components/ChartLxdz/LxdzFinance.vue";
import workerBase from "@/components/ChartWorker/WorkerBase.vue";
import barChart from "@/views/adminRole/BarChart.vue";
import hbarChart from "@/views/adminRole/HBarChart.vue";
import mbarChart from "@/views/adminRole/MBarChart.vue";
import pieChart from "@/views/adminRole/PieChart.vue";
import bingChart from "@/views/adminRole/BingChart.vue";

import {
  getChartData1,
  getChartData2,
  getChartData3,
  getChartData4,
  getChartData5,
  getChartData6,
  getChartData7,
  listChartData,
  getChartData11,
  getChartData12,
  getChartData13,
  getChartData14,
  getChartData15,
  getChartData16,
  getChartData17,
  getChartData18,
  getChartData181,
  getChartData182,
  getChartData183,
  listData,
  getChartData31To40,
  getChartData51,
  getChartData52,
} from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  components: {
    chartFinance,
    provinceFinance,
    lxdzFinance,
    workerBase,
    barChart,
    pieChart,
    hbarChart,
    mbarChart,
    bingChart,
  },
  data() {
    return {
      form: {},
      chartHeight: "height: 420px;width:100%;",
      dialogVisible: false,
      activeName: "1",
      chartTheme: "macarons",
      themes: [
        "macarons",
        "macarons2",
        "vintage",
        "blue",
        "cool",
        "forest",
        "fruit",
        "green",
        "roma",
        "shine",
        "london",
        "infographic",
      ],
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",
      option_n: null,
      currentId: "",
      etype: 2,
      listZj: ["音像", "电子", "图书", "期刊", "报纸", "网络"],
      checkListZj: ["音像", "电子"],
      listZj2: ["图书", "期刊", "报纸", "网络", "无"],
      checkListZj2: ["图书", "期刊"],
      columnMap: {
        chart_2: { provincename: "省局", name: "出版单位", type: "音电资质" },
        chart_3: { provincename: "省局", name: "出版单位", zizhi: "出版资质" },
        chart_4: { provincename: "省局", name: "出版单位", zizhi2: "主营出版业务" },
        chart_5: { provincename: "省局", name: "出版单位", zizhi2: "主营出版业务" },
        chart_6: { provincename: "省局", name: "出版单位", isindependentlp: "否为独立法人" },
        chart_7: { provincename: "省局", name: "出版单位", nature: "企业性质", unittype: "单位类型" },
        chart_11: { orgname: "出版单位", value: "出版数量" },
        chart_12: { orgname: "出版单位", publicationname: "出版物名称", value: "时长" },
        chart_13: { orgname: "出版单位", publicationname: "出版物名称", value: "内容来源类型" },
        chart_14: { orgname: "出版单位", publicationname: "出版物名称", value: "书配盘" },
        chart_15: { orgname: "出版单位", ztNums: "实（载）体出版", networkNums: "利用信息网络出版" },
        chart_16: { orgname: "出版单位", xhsdNums: "新华书店", gpsNums: "馆配商", yjNums: "邮局" },
        chart_17: { provincename: "省局", name: "出版单位", expandbusiness: "拓展方向" },
        chart_18: {
          provincename: "省局",
          name: "出版单位",
          operationprojectwebnum: "业务网站",
          operationprojectdatabasenum: "专业数据库",
          operationprojectwechatnum1: "微信公众号个数",
          operationprojectwechatnum2: "微信公众号总用户数",
          operationprojectappnum: "小程序或APP",
          operationprojectweibonum: "微博",
          operationprojectothernum: "其他",
        },
        chart_181: { name: "年度", value: "销售数量（张/盒）" },
        chart_182: { name: "年度", value: "实载体", value: "利用信息网络出版", value: "总计" },
        chart_183: { name: "年度", value: "年收入（万元）" },
        chart_21: { orgname: "出版单位", value: "出版数量" },
        chart_22: { orgname: "出版单位", publicationname: "出版物名称", value: "时长" },
        chart_23: { orgname: "出版单位", publicationname: "出版物名称", value: "内容来源类型" },
        chart_24: { orgname: "出版单位", publicationname: "出版物名称", value: "书配盘" },
        chart_25: { orgname: "出版单位", ztNums: "实（载）体出版", networkNums: "利用信息网络出版" },
        chart_26: { orgname: "出版单位", xhsdNums: "新华书店", gpsNums: "馆配商", yjNums: "邮局" },
        chart_27: { provincename: "省局", name: "出版单位", expandbusiness: "拓展方向" },
        chart_28: {
          provincename: "省局",
          name: "出版单位",
          operationprojectwebnum: "业务网站",
          operationprojectdatabasenum: "专业数据库",
          operationprojectwechatnum1: "微信公众号个数",
          operationprojectwechatnum2: "微信公众号总用户数",
          operationprojectappnum: "小程序或APP",
          operationprojectweibonum: "微博",
          operationprojectothernum: "其他",
        },
        chart_281: { name: "年度", value: "销售数量（张/盒）" },
        chart_282: { name: "年度", value: "年收入（万元）" },
        chart_283: { name: "年度", value: "品牌数数量" },
        chart_31: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "音电类型" },
        chart_32: { provincename: "省局", name: "出版单位", value: "出版专业职业资格中级及以上职称占比" },
        chart_33: { provincename: "省局", name: "出版单位", value: "领导班子岗位培训合格证书持有占比" },
        chart_34: { provincename: "省局", name: "出版单位", value: "领导班子出版专业职业资格证书中级及以上占比" },
        chart_35: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "政治面貌" },
        chart_36: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "文化程度" },
        chart_37: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_38: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称等级" },
        chart_39: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称等级" },
        chart_40: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_41: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率",
        },
        chart_42: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数",
        },
        chart_43: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_44: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率",
        },
        chart_45: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率",
        },
        chart_46: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数",
        },
        chart_47: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数",
        },
        chart_51: {
          name: "类别",
          value: "<100",
          value2: "100-500",
          value3: "500-1000",
          value4: "1000-5000",
          value5: "5000-10000",
          value6: ">=10000",
        },
        chart_52: {
          name: "年度",
          value: "<0",
          value2: "0",
          value3: "0-0.5",
          value4: "0.5-1",
          value5: "1-5",
          value6: "5-10",
          value7: "10-20",
          value8: ">=20",
        },
        chart_n: {},
      },
      queryFilter: {},
      queryFilterN: {},
      queryVisible: {},
      queryData: {},
      querySort: {},
      txtNumsData: {},
      dataArray: {},
      searchDataParams: {},
      txtNums: [0, 0, 0, 0, 0, 0],
      txtNums2: [0, 0, 0, 0],
      roundKey: new Date().getTime(),
      rangeValus: {
        "<10": "0-10",
        "10-20": "10-20",
        "20-100": "20-100",
        "100-1000": "100-1000",
        ">=1000": "1000",
        "10-30": "10-30",
        "30-60": "30-60",
        "60-120": "120-600",
        "600-1200": "600-1200",
        ">=1200": "1200",
      },
    };
  },
  created: function () {
    let queryVisible = {};
    let queryData = {};
    let querySort = {};
    let txtNumsData = {};
    for (let key in this.columnMap) {
      queryVisible[key] = false;
      queryData[key] = [];
      let jpo = {};
      for (let key2 in this.columnMap[key]) {
        jpo[key2] = "sort";
      }
      querySort[key] = jpo;
      txtNumsData[key] = {};
    }
    this.queryVisible = queryVisible;
    this.queryData = queryData;
    this.querySort = querySort;
    this.txtNumsData = txtNumsData;
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", () => {
      that.initCharts();
    });
    this.initCharts();
    this.initYxCharts();
    this.initDzCharts();
    this.initChartsPerson();
  },
  methods: {
    initCharts() {
      this.getData2("chart_2", "出版单位音像电子资质统计", {});
      this.searchChart3Data();
      this.searchChart4Data();
      this.getData5("chart_5", "出版单位主营出版业务的营收高于音像电子的业务统计", {});
      this.initCharts2();
      this.initChartsBusiness();
    },
    searchChart3Data() {
      this.getData3("chart_3", "出版单位出版资质统计", {
        zizhi1list: this.checkListZj,
        zizhi1str: this.checkListZj.join(","),
      });
    },
    searchChart4Data() {
      this.getData4("chart_4", "出版单位主营出版业务营收高于音像电子业务统计", {
        zizhi2list: this.checkListZj2,
        zizhi2str: this.checkListZj2.join(","),
      });
    },
    initYxCharts() {
      this.getData11("chart_11", "2023-2024年度音像制品出版单位出版品种数分段统计", { type: 1 });
      this.getData12("chart_12", "2023-2024年度音音像制品节目时长分段统计", { type: 1 });
      this.getData13("chart_13", "2023-2024年度音像制品内容来源类型统计", { type: 1 });
      this.getData14("chart_14", "2023-2024年度音像制品书配盘统计", { type: 1 });
      this.getData15("chart_15", "2023-2024年度音像制品载体形式统计", { type: 1 });
      //this.getData16("chart_16", "2023-2024音像制品出版渠道统计", { type: 1 });
      this.getData17("chart_17", "2023-2024年度除传统光盘载体外音像制品出版单位拓展方向分布情况", { type: 1 });
      this.getData18("chart_18", "2023-2024年度音像制品出版单位结合音像电子业务开设并运营的项目分布情况", { type: 1 });
      this.getData181("chart_181", "2017-2024年音像制品实（载）体出版销售数量（亿张/盒）统计", { type: 1 });
      this.getData182("chart_182", "2017-2024年音像制品出版年收入（亿元）统计", { type: 1 });
      this.getData183("chart_183", "2017-2024年音像制品品种数统计", { type: 1 });
    },
    initDzCharts() {
      this.getData11("chart_21", "2023-2024年度电子出版单位出版品种数分段统计", { type: 2 });
      this.getData12("chart_22", "2023-2024年度电子出版物数据容量分段统计", { type: 2 });
      this.getData13("chart_23", "2023-2024年度电子出版物内容来源类型统计", { type: 2 });
      this.getData14("chart_24", "2023-2024年度电子出版物书配盘统计", { type: 2 });
      this.getData15("chart_25", "2023-2024年度电子出版物载体形式统计", { type: 2 });
      //this.getData16("chart_26", "2023-2024电子出版物出版渠道统计", { type: 2 });
      this.getData17("chart_27", "2023-2024年度除传统光盘载体外电子出版物出版单位拓展方向分布情况", { type: 2 });
      this.getData18("chart_28", "2023-2024年度电子出版物出版单位结合音像电子业务开设并运营的项目分布情况", {
        type: 2,
      });
      this.getData181("chart_281", "2017-2024年电子出版物实（载）体出版销售数量（亿张/盒）统计", { type: 2 });
      this.getData182("chart_282", "2017-2024年电子出版物年收入（亿元）统计", { type: 2 });
      this.getData183("chart_283", "2017-2024年电子出版物品种数统计", { type: 2 });
    },
    initCharts2() {
      this.getData6("chart_6", "法人类型统计", {});
      this.getData7("chart_7", "单位性质统计", {});
    },
    initChartsBusiness() {
      this.getData51("chart_51", "出版单位注册资本或开办资金、资产、负债分段统计", {});
      this.getData52("chart_52", "出版单位资产收益率分段统计", {});
    },
    initChartsPerson() {
      let tit = {
        31: "音像及电子中级职称人数统计",
        32: "出版专业职业资格中级及以上职称占比情况统计",
        33: "领导班子岗位培训合格证书持有占比统计",
        34: "领导班子出版专业职业资格证书中级及以上占比统计",
        35: "政治面貌统计",
        36: "文化程度统计",
        37: "职称系列统计",
        38: "音像电子人员职称统计",
        39: "出版专业人员职称统计",
        40: "各专业高级职称编辑人数统计",
        41: "音像领导班子成员持证上岗率情况",
        42: "音像取得国家出版专业职业资格\n编辑人员统计",
        43: "各专业中级职称编辑人数统计",
        44: "电子领导班子成员持证上岗率统计",
        45: "领导班子成员持证上岗率统计",
        46: "音像具有中级及以上出版专业\n职业资格人员统计",
        47: "电子具有中级及以上出版专业\n职业资格人员统计",
      };
      for (var i = 32; i <= 47; i++) {
        if (i == 33) {
          continue;
        }
        this.getData31To42("chart_" + i, tit[i], { chartn: "chart" + i });
      }
    },
    // getData1(params) {
    //   getChartData1(params).then((response) => {
    //     let data = {
    //       title: "参检单位资质占比",
    //       subtext: "共计数量：" + response.total,
    //       data: response.list,
    //       datalist: response.datalist,
    //     };
    //     this.chart_1("chart_1", data);
    //   });
    // },
    getData2(id, title, params) {
      getChartData2(params).then((response) => {
        let data = {
          title: title,
          data: response.list,
          //datalist: response.datalist,
        };
        let json = {};
        for (var index in data.data) {
          var item = data.data[index];
          json[item.name] = item.value;
        }
        let szzNums = Number(json["双资质"]);
        let comNums = Number(json["单位数量"]);
        let yxNums = Number(json["音像"]);
        let dzNums = Number(json["电子"]);
        let nums = Number(yxNums) - Number(dzNums);
        let txtNums = [comNums, szzNums, yxNums - szzNums, dzNums - szzNums, yxNums, dzNums];
        this.txtNums = txtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData3(id, title, params) {
      getChartData3(params).then((response) => {
        let data = {
          title: title,
          data: response.list,
          //datalist: response.datalist,
        };
        let txtNums2 = response.datalist.map((item) => item.value);
        // if (response.datalist && response.datalist.length > 0) {
        //   var a1 = 0;
        //   var a2 = 0;
        //   var a3 = 0;
        //   var a4 = 0;
        //   for (var i in response.datalist) {
        //     var zizhi = response.datalist[i].zizhi || "";
        //     if (zizhi.indexOf("图书") != -1) {
        //       a1++;
        //     }
        //     if (zizhi.indexOf("期刊") != -1) {
        //       a2++;
        //     }
        //     if (zizhi.indexOf("报纸") != -1) {
        //       a3++;
        //     }
        //     if (zizhi.indexOf("网络") != -1) {
        //       a4++;
        //     }
        //   }
        // }
        // txtNums2 = [a1, a2, a3, a4];
        this.txtNums2 = txtNums2;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData4(id, title, params) {
      getChartData4(params).then((response) => {
        let data = {
          title: title,
          data: response.list,
          datalist: response.datalist,
        };
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData5(id, title, params) {
      getChartData5(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData6(id, title, params) {
      getChartData6(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData7(id, title, params) {
      getChartData7(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData11(id, title, params) {
      getChartData11(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[" " + po.name + " "] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData12(id, title, params) {
      getChartData12(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData13(id, title, params) {
      getChartData13(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData14(id, title, params) {
      getChartData14(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData15(id, title, params) {
      getChartData15(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData16(id, title, params) {
      getChartData16(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData17(id, title, params) {
      getChartData17(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData18(id, title, params) {
      getChartData18(params).then((response) => {
        let data = {
          title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData181(id, title, params) {
      getChartData181(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist || [],
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData182(id, title, params) {
      getChartData182(params).then((response) => {
        console.log("BB==", response);
        let data = {
          title,
          data: response,
          datalist: response.datalist || [],
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData183(id, title, params) {
      getChartData183(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist || [],
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData51(id, title, params) {
      getChartData51(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData52(id, title, params) {
      getChartData52(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          let po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        this.txtNumsData[id] = chartTxtNums;
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    getData31To42(id, title, params) {
      getChartData31To40(params).then((response) => {
        let data = {
          title,
          data: response.list,
          datalist: response.datalist,
        };
        var chartTxtNums = {};
        var total = 0;
        for (var i in response.list) {
          let po = response.list[i];
          if (id == "chart_33" || id == "chart_34" || id == "chart_32") {
            chartTxtNums[" " + po.name + " "] = po.value;
          } else {
            chartTxtNums[po.name] = po.value;
          }
          total += Number(po.value);
        }
        let tjson = {};
        if (id == "chart_38" || id == "chart_39") {
          tjson = { 人员总数: total };
        }
        this.txtNumsData[id] = { ...tjson, ...chartTxtNums };
        this.dataArray[id] = data;
        this.searchDataParams[id] = params;
        this.roundKey = new Date().getTime();
      });
    },
    listTableData(id, myChart, option, p) {
      let params = { chartn: id.replace("_", ""), ...(this.searchDataParams[id] || {}), ...(p || {}) };
      console.log("=====", this.searchDataParams[id]);
      console.log("params=====", params);
      const loading = this.$loading({
        lock: true,
        text: "数据查询中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      listData(params).then((response) => {
        loading.close();
        if (myChart == null) {
          this.createDataHtml(id, response.datalist);
          this.setDisplayVisible(id, option);
        } else {
          this.createDataHtml(id, response.datalist);
          this.backEcharts(id, myChart, option);
        }
      });
    },
    setQueryVisible(id) {
      if (this.queryVisible[id]) {
        this.queryVisible[id] = false;
      } else {
        this.queryVisible[id] = true;
      }
    },
    createDataHtml(id, datalist, search) {
      let columns = Object.keys(this.columnMap[id]);
      let html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html +=
          ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' +
          (Number(index) + 1) +
          "</td>";
        columns.forEach((key, index) => {
          html +=
            ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' +
            this.formatEmpty(item[key]) +
            "</td>";
        });
        html += "</tr>";
      }
      if (!search) {
        this.queryData[id] = datalist;
      }
      if (this.dialogVisible) {
        $("#echart_n_html").html(html);
        this.$forceUpdate();
      } else {
        $("#" + id + "_html").html(html);
      }
    },
    async downloadData(id) {
      var sortAttr = this.querySort[id];
      var column = "";
      var sort = "";
      for (var key in sortAttr) {
        var val = sortAttr[key];
        if (val != "sort") {
          column = key;
          sort = val;
        }
      }
      let datalist = this.searchData(id, column, sort, "yes");
      var columns = this.columnMap[id == "chart_n" ? this.currentId : id];
      let cellWidths = [{ wpx: 240 }, { wpx: 300 }, { wpx: 150 }, { wpx: 150 }];
      var list = [];
      for (var i in datalist) {
        var po = datalist[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[key];
        }
        list.push(data);
      }
      var filename = "统计数据" + moment().format("YYYY-MM-DD") + "_" + new Date().getTime() + ".xlsx";
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
    searchData(id, column, sort, exp) {
      if (id == "chart_n") {
        id = this.currentId;
      }
      var datalist = [...this.queryData[id]];
      if (column && sort != "sort") {
        datalist.sort(function (a, b) {
          if (sort == "asc") {
            return (a[column] || "").localeCompare(b[column] || "");
          }
          if (sort == "desc") {
            return (b[column] || "").localeCompare(a[column] || "");
          }
          return 0;
        });
      }
      let columns = this.columnMap[id];
      console.log("columns===", columns);
      var list = [];
      for (var i in datalist) {
        var po = datalist[i];
        var flag = true;
        for (var key in columns) {
          flag = this.searchFlag(po, key);
          if (!flag) {
            break;
          }
        }
        if (flag) {
          list.push(po);
        }
      }
      if (exp == "yes") {
        return list;
      } else {
        this.createDataHtml(id, list, true);
      }
    },
    searchFlag(po, column) {
      var flag = true;
      var params = {};
      if (this.dialogVisible) {
        params = this.queryFilterN;
      } else {
        params = this.queryFilter;
      }
      if (!isEmpty(params[column])) {
        let sval = params[column];
        if (sval in this.rangeValus) {
          let val = po[column] || 0;
          if (sval == ">=1000" || sval == ">=1200") {
            sval = this.rangeValus[sval];
            console.log(sval, val);
            if (Number(val) >= Number(sval)) {
              flag = true;
            } else {
              flag = false;
            }
          } else {
            let arr = this.rangeValus[sval].split("-");
            if (Number(val) >= Number(arr[0]) && Number(val) < Number(arr[1])) {
              flag = true;
            } else {
              flag = false;
            }
          }
        } else {
          if ((po[column] || "").indexOf(params[column]) != -1) {
            flag = true;
          } else {
            flag = false;
          }
        }
      }
      return flag;
    },
    sortData(id, column, sort) {
      let currentSrot = "";
      if (sort == "sort") {
        currentSrot = "asc";
      } else if (sort == "asc") {
        currentSrot = "desc";
      } else if (sort == "desc") {
        currentSrot = "sort";
      }
      for (var key in this.querySort[id]) {
        if (key != column) {
          this.querySort[id][key] = "sort";
        }
      }
      this.querySort[id][column] = currentSrot;
      this.searchData(id, column, currentSrot);
    },
    chagenZjVal() {
      this.searchChart3Data();
    },
    chagenZjVal2() {
      this.searchChart4Data();
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    handleClick: function (tab, event) {
      var that = this;
      // console.log("===", tab);
      // if (tab.name == "1") {
      //   this.initCharts();
      // } else if (tab.name == "3") {
      //   this.initYxCharts();
      // } else if (tab.name == "4") {
      //   this.initDzCharts();
      // } else if (tab.name == "5") {
      //   this.initChartsPerson();
      // }
      // 设定延迟时间以便画面切换后尺寸响应
      this.roundKey = new Date().getTime();
    },
    chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setDisplayVisible(id, option) {
      this.option_n = option;
      this.currentId = id;
      this.dialogVisible = true;
      this.queryVisible["chart_n"] = false;
      //设置弹出框查询字段和排序字段
      let columns = this.columnMap[this.currentId];
      for (var key in columns) {
        this.queryFilterN[key] = "";
        this.querySort["chart_n"][key] = "";
      }
      this.clearQueryFilerN();
    },
    openedDialog() {
      var height = $(window).height() - 220;
      if (this.etype == 1) {
        $("#tj1").attr("class", "col-lg-12");
        $("#tj2").attr("class", "col-lg-12");
        $("#tj2").css("padding-top", "10px");
        $("#tj2").css("padding-bottom", "10px");
        height = height / 2;
      }
      $("#echart_n").css("height", height + "px");
      $("#echart_n_table").css("height", height + "px");
      height = height - 43;
      $("#echart_n_table table tbody").css("height", height + "px");
      this.searchData("chart_n");
      this.initChartN();
    },
    initChartN() {
      this.disposeChart("echart_n");
      var myChartn = echarts.init(document.getElementById("echart_n"), this.chartTheme);
      // var htm=$("#"+this.currentId+"_table").html().replace('fa fa-mail-reply','').replace('searchFilterBtn','searchFilterBtnN').replace(/searchInput/g,'searchInputN');
      // $("#echart_n_table").html(htm);
      let option_n = this.option_n;
      delete option_n.toolbox.feature.myTool2;
      delete option_n.toolbox.feature.myTool1;
      myChartn.setOption(option_n);
      window.onresize = function () {
        myChartn.resize();
      };
      var height = $(window).height() - 220;
      if (this.etype == 1) {
        height = height / 2;
      }
      $("#echart_n_table").css("height", height + "px");
      height = height - 73;
      $("#echart_n_table table tbody").css("height", height + "px");
    },
    formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
    handleChangeTheme(val) {
      this.chartTheme = val;
      this.initCharts();
    },
    onInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;
}
.echart_table {
  height: 420px;
  width: 100%;
  overflow: hidden;
  display: none;
}
.el-checkbox + .el-checkbox {
  margin-left: 15px;
}
.el-checkbox__label {
  padding-left: 4px !important;
}

.searchInput {
  margin-top: 6px;
}

.searchInputN {
  margin-top: 6px;
}

.searchFilerCls {
  color: #ff9800 !important;
}

.searchFilerClsN {
  float: right;
  padding-top: 3px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// chart1.vue?6b7e9367